import { Badge } from "@mui/material";
import moment from "moment/moment";
import { gpsStatusBadgeColor } from "utils/constant";

const getKeyWithSpecialValue = (obj, specialValue) => {
    const entry = Object.entries(obj).find(
        ([key, value]) => value === specialValue
    );
    return entry ? entry[0] : undefined;
};

const cond = [null, undefined, 'undefined', 'null'];

const formatValue = (value, format, display_ui) => {
    let ans = value;
    if (typeof value === 'boolean') {
        ans = value ? 'True' : 'False'
    }

    if (display_ui === 'badge') {
        return <Badge
            color={gpsStatusBadgeColor(ans)}
            variant={'standard'}
            badgeContent={ans}
            style={{ marginLeft: "15px" }}
        ></Badge>
    }

    if (display_ui === 'duration') {
        let dur = moment.duration({ from: ans, to: new Date() });
        return dur.humanize()
    }

    return ans + format
}

const formatValueForSignal = (value) => {
    let ans = value;
    if (typeof value === 'boolean') {
        ans = value ? 'On' : 'Off'
    }

    return ans
}

export {
    getKeyWithSpecialValue,
    cond,
    formatValue,
    formatValueForSignal
};